/* eslint-env node */

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import { createApp } from 'vue';

import i18n from './i18n';
import VueApexCharts from 'vue3-apexcharts';
import en from 'apexcharts/dist/locales/en.json';
import es from 'apexcharts/dist/locales/es.json';
import ca from 'apexcharts/dist/locales/ca.json';

import './bootstrap';
import { ZiggyVue } from 'ziggy-js';
import { Ziggy } from './ziggy';

const app = createApp({});

app.use(ZiggyVue, Ziggy);
app.use(i18n);

window.Apex.chart = {
    locales: [en, es, ca],
    defaultLocale: document.documentElement.lang || 'es',
};
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
app.component('apexchart', VueApexCharts);
app.component('GlobalSearchHeaderInput', require('./components/GlobalSearchHeaderInput.vue').default);
app.component('OpenMobileSidebarButton', require('./components/OpenMobileSidebarButton.vue').default);
app.component('mobile-sidebar', require('./components/MobileSidebar.vue').default);
app.component('avatar-dropdown', require('./components/AvatarDropdown.vue').default);
app.component('sidebar-dropdown', require('./components/SidebarDropdown.vue').default);
app.component('dropdown-button', require('./components/DropdownButton.vue').default);
app.component('dropdown-icon-button', require('./components/DropdownIconButton').default);
app.component('breadcrumb-dropdown-button', require('./components/BreadcrumbDropdownButton.vue').default);
app.component('tabs', require('./components/Tabs.vue').default);
app.component('tab', require('./components/Tab.vue').default);
app.component('global-search', require('./components/GlobalSearch.vue').default);
app.component('group-selector', require('./components/GroupSelector.vue').default);
app.component('select-with-preferences', require('./components/SelectWithPreferences.vue').default);
app.component('app-button', require('./components/AppButton.vue').default);
app.component('sidebar-items-for-teacher', require('./Shared/SidebarItemsForTeacher.vue').default);
app.component('sidebar-items-for-relative', require('./Shared/SidebarItemsForRelative.vue').default);
app.component('FormLabel', require('./components/Forms/FormLabel.vue').default);
app.component('FormInput', require('./components/Forms/FormInput.vue').default);

app.component('activity-grade', require('./components/pageSpecific/ActivityGrade.vue').default);
app.component('student-file-tag-selector', require('./components/pageSpecific/StudentFileTagSelector.vue').default);
app.component('grades-bar-graph-sortable', require('./components/pageSpecific/GradesBarGraphSortable.vue').default);
app.component('intervention-type-level', require('./components/pageSpecific/InterventionTypeLevel.vue').default);
app.component('activity-menu-options', require('./components/pageSpecific/ActivityMenuOptions.vue').default);
app.component('scholarship-input', require('./components/pageSpecific/ScholarshipInput.vue').default);
app.component('password-input', require('./components/pageSpecific/PasswordInput.vue').default);
app.component('link-batch-create', require('./components/pageSpecific/LinkBatchCreate.vue').default);
app.component('material-batch-create', require('./components/pageSpecific/MaterialBatchCreate.vue').default);
app.component('avatar-uploader', require('./components/pageSpecific/AvatarUploader.vue').default);
app.component('student-relatives-selector', require('./components/pageSpecific/StudentRelativesSelector.vue').default);
app.component('messaging-page', require('./components/pageSpecific/messaging/MessagingPage.vue').default);
app.component('foul-message-suggestions', require('./components/pageSpecific/FoulMessageSuggestions.vue').default);
app.component('StudentProfileContactList', require('./components/pageSpecific/StudentProfileContactList.vue').default);
app.component('dimension-grades-table', require('./components/pageSpecific/DimensionGradesTable.vue').default);
app.component('nav-links', require('./components/NavLinks.vue').default);

app.mount('#app');

window.app = app;
